import { ChangeDetectionStrategy, Component, ElementRef, input, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ChatAudio } from '../ai-broker-chat.models';

@Component({
  selector: 'app-chat-audio',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  template: `
    <div class="audio-card p-2 surface-card border-round-lg border-1 border-gray-300 flex align-items-center gap-3 my-2">
      <button pButton 
              [icon]="isPlaying() ? 'pi pi-pause' : 'pi pi-play'" 
              (click)="togglePlay()"
              class="p-button-rounded p-button-sm p-button-primary shadow-2">
      </button>
      
      <div class="flex-grow-1 flex flex-column gap-1">
        <div class="waveform-placeholder h-1rem surface-200 border-round overflow-hidden relative">
          <div class="progress-bar bg-primary h-full absolute top-0 left-0" 
               [style.width.%]="progress()"></div>
        </div>
        <div class="flex justify-content-between text-xs text-color-secondary font-medium">
          <span>{{ data().name || 'Voice Message' }}</span>
          <span>{{ data().durationLabel || '0:00' }}</span>
        </div>
      </div>
      
      <audio #audioElement [src]="data().url" (timeupdate)="onTimeUpdate()" (ended)="onEnded()"></audio>
    </div>
  `,
  styles: [`
    .audio-card {
      min-width: 250px;
      max-width: 350px;
      transition: all 0.2s ease;
    }
    .audio-card:hover {
      border-color: var(--primary-color);
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    }
    .progress-bar {
      transition: width 0.1s linear;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatAudioComponent {
  data = input.required<ChatAudio>();
  @ViewChild('audioElement') audioRef!: ElementRef<HTMLAudioElement>;

  isPlaying = signal(false);
  progress = signal(0);

  togglePlay() {
    const audio = this.audioRef.nativeElement;
    if (this.isPlaying()) {
      audio.pause();
      this.isPlaying.set(false);
    } else {
      audio.play();
      this.isPlaying.set(true);
    }
  }

  onTimeUpdate() {
    const audio = this.audioRef.nativeElement;
    if (audio.duration) {
      this.progress.set((audio.currentTime / audio.duration) * 100);
    }
  }

  onEnded() {
    this.isPlaying.set(false);
    this.progress.set(0);
  }
}
